import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class OrderEndpoint extends BaseEndpoint {}
